import { styled } from '@mui/material';

export const FilterInputWrapper = styled('div')<{ layout: 'full' | 'half' }>(({ layout }) => ({
  width: layout === 'half' ? 'calc(50% - 8px)' : '100%',
  position: 'relative',
}));
